'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MotionBehaviourProvider: function() {
        return MotionBehaviourProvider;
    },
    useMotionBehaviourContext: function() {
        return useMotionBehaviourContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const MotionBehaviourContext = _react.createContext(undefined);
const MotionBehaviourProvider = MotionBehaviourContext.Provider;
const useMotionBehaviourContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(MotionBehaviourContext)) !== null && _React_useContext !== void 0 ? _React_useContext : 'default';
};
